// Visits and service points (docs/plans/phase1-registration.md §3.3).
import {
  servicePointSchema,
  visitSchema,
  type OpenVisitRequest,
  type cancelVisitRequestSchema,
} from '@wodi/shared';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';

import { api } from './client.ts';

/** Active service points at the session's facility, for choosing the first queue. */
export const servicePointsQuery = queryOptions({
  queryKey: ['service-points'],
  queryFn: () => api('GET', '/service-points', { schema: z.array(servicePointSchema) }),
  staleTime: 60_000,
});

export const visitQuery = (id: string) =>
  queryOptions({
    queryKey: ['visits', id],
    queryFn: () => api('GET', `/visits/${id}`, { schema: visitSchema }),
  });

export function openVisit(body: OpenVisitRequest) {
  return api('POST', '/visits', { body, schema: visitSchema });
}

export function cancelVisit(id: string, body: z.input<typeof cancelVisitRequestSchema>) {
  return api('POST', `/visits/${id}/cancel`, { body, schema: visitSchema });
}
